import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import { Box } from "@mui/material";

import { ResourceError } from "./resource-error";

export const LoadingError: FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <ResourceError
        message="Error loading data, please try again."
        onReload={() => {
          navigate(0);
        }}
      />
    </Box>
  );
};
